module.exports = __webpack_public_path__ + "img/catering_menu_7.801dc798.jpg";